import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
	selector: 'tab',
	templateUrl: "./tab.html",
	styles: [require("./tab.scss")]
})
export class Tab {
	@Input('tabTitle') title: string;
	@Input() active = false;
	@Input('tabDisabled') disabled;
	@Input() requiredRole: string;
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/tab/tab.component.ts